var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.391,
    height: 20.152,
    viewBox: "0 0 22.391 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-photo-camera",
    "data-name": "Icon material-photo-camera",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_401",
    "data-name": "\\uD328\\uC2A4 401",
    d: "M20.365,16.783A3.583,3.583,0,1,1,16.783,13.2,3.583,3.583,0,0,1,20.365,16.783Z",
    transform: "translate(-5.587 -5.587)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_402",
    "data-name": "\\uD328\\uC2A4 402",
    d: "M10.837,3,8.788,5.239H5.239A2.246,2.246,0,0,0,3,7.478V20.913a2.246,2.246,0,0,0,2.239,2.239H23.152a2.246,2.246,0,0,0,2.239-2.239V7.478a2.246,2.246,0,0,0-2.239-2.239H19.6L17.554,3ZM14.2,19.794a5.6,5.6,0,1,1,5.6-5.6A5.6,5.6,0,0,1,14.2,19.794Z",
    transform: "translate(-3 -3)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f56f021142db2ac6212ce9248d5169f7.svg";
export { ForwardRef as ReactComponent };